var render = function render(){var _vm=this,_c=_vm._self._c;return (['LbStat'].includes(_vm.$route.name))?_c('router-view'):_c('PageHeaderLayout',{staticClass:"main-page-content-nav"},[_c('ApeMenu',{attrs:{"menus":_vm.menus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }